import { useState, useCallback } from "react";

const storageKey = (bannerId, userId) => `dismissed:${bannerId}:${userId || "anon"}`;

const readFromStorage = (bannerId, userId) => {
  try {
    return localStorage.getItem(storageKey(bannerId, userId)) === "1";
  } catch {
    return false;
  }
};

const writeToStorage = (bannerId, userId) => {
  try {
    localStorage.setItem(storageKey(bannerId, userId), "1");
  } catch {}
};

/**
 * Per-user, per-banner dismissal persisted in localStorage.
 * @param {string} bannerId  stable id for the banner (e.g. "freePlanBanner")
 * @param {string} userId    current user id
 * @returns {{ dismissed: boolean, dismiss: () => void }}
 */
export function useDismissedBanner(bannerId, userId) {
  const [dismissed, setDismissed] = useState(() => readFromStorage(bannerId, userId));

  const dismiss = useCallback(() => {
    writeToStorage(bannerId, userId);
    setDismissed(true);
  }, [bannerId, userId]);

  return { dismissed, dismiss };
}
